<template>
    <div>
        <slot></slot>
    </div>
</template>
<script>
export default {
    name: 'Carousel4Wrapper',
}
</script>

<style>
    
</style>